import { createActions, createAction } from "redux-actions";

export const authLoginAsyncAction = createActions(
	{
		REQUEST: (payload) => payload,
		SUCCESS: (payload) => payload,
		FAILURE: (error) => error,
	},
	{
		prefix: "AUTH_LOGIN",
		namespace: "_",
	}
);

export const authLogoutAction = createAction("AUTH_LOGOUT");
